export default [
  {
    name: 'Metrics',
    path: '/metrics',
    component: () => import(/* webpackChunkName: "metrics" */ '@/views/Metrics/Metrics'),
    meta: {
      title: 'headerTitles["Metrics Page"]',
    },
  },
  {
    name: 'ScheduleCA',
    path: '/schedule',
    component: () => import(/* webpackChunkName: "Schedule" */ '@/views/Schedule/Schedule'),
    meta: {
    },
  },
  {
    name: 'ClinicProfile',
    path: '/clinic-profile/:id',
    component: () => import(/* webpackChunkName: "ClinicProfile" */ '@/views/ClinicProfile/ClinicProfile'),
    meta: {
      title: 'basicMedicalExpressions["clinicProfile"]',
    },
  },
  {
    name: 'ProviderProfile',
    path: '/provider-profile/:id/:page?',
    component: () => import(/* webpackChunkName: "ProviderProfile" */ '@/views/ProviderProfile/ProviderProfile'),
    meta: {
      title: 'constants["providerInfo"]',
    },
  },
  {
    name: 'Inventory',
    path: '/inventory',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/Inventory/Inventory'),
    meta: {
      title: 'headerTitles["Remote Patient Monitoring"]',
    },
  },
  {
    name: 'Enrollment',
    path: '/enrollment',
    component: () => import(/* webpackChunkName: "enrollment" */ '@/views/Enrollment/Enrollment'),
    meta: {
      title: 'headerTitles["enrollment"]',
    },
  },
  {
    name: 'EnrollmentDetail',
    path: '/enrollment/:patientId',
    component: () => import(/* webpackChunkName: "enrollment-detail" */ '@/views/Enrollment/EnrollmentDetail'),
    meta: {
      title: 'headerTitles["enrollment"]',
    },
    props: route => ({
      patientId: route.params.patientId,
    }),
  },
  {
    name: 'Orders',
    path: '/orders',
    component: () => import(/* webpackChunkName: "orders" */ '@/views/Orders/Orders'),
    meta: {
      title: 'headerTitles["orders"]',
    },
  },
  {
    name: 'Monitoring',
    path: '/monitoring',
    component: () => import(/* webpackChunkName: "monitoring" */ '@/views/Monitoring/Monitoring'),
    meta: {
      title: 'headerTitles["monitoring"]',
    },
  },
  {
    path: '/data-import',
    name: 'DataImport',
    component: () => import('@/views/DataImport/DataImport'),
    meta: {
      title: 'sidebar.dataImport',
    },
  },
  {
    path: '/data-import/upload',
    name: 'DataImportUploadCSV',
    component: () => import('@/views/DataImport/components/UploadCSV'),
    meta: {
      title: 'constants.manageOptions.uploadCSV',
      permission: {
        name: 'UPLOAD_CSV',
        role: 'CLINIC_ADMIN',
      },
    },
  },
  {
    path: '/data-import/:fileId',
    name: 'DataImportFixErrors',
    component: () => import('@/views/DataImport/components/FixErrors'),
    meta: {
      title: 'sidebar.dataImport',
      permission: {
        name: 'UPLOAD_CSV',
        role: 'CLINIC_ADMIN',
      },
    },
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "support" */ '@/views/Support/Support'),
    meta: {
      title: 'headerTitles["Support"]',
    },
  },
];
